<template>
  <div>
    <div dir="rtl">
      <div v-if="!payload.isBoolean" >
        <BaseInput v-model="setting.value" label="שם :" />
      </div>
      <div v-else>
        <label>צבע : </label>
        <select v-model="setting.value">
          <option value="remove_filter">NOT SELECTED</option>
          <option v-for="(option, idx) in ['true', 'false']" :key="idx" :value="option">{{
            option
          }}</option>
        </select>
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit(true)" :class="{ 'is-loading': is_submitting }" class="button is-info is-rounded"
        >הזן ורענן לי את הדף</a
      >
      <a
        @click="submit(false)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        style="margin: 10px"
        >הזן ואל תרענן</a
      >
    </div>
  </div>
</template>
<script>
// libraries
import { mapActions } from 'vuex'

// components
import BaseInput from '@/components/BaseInput'

export default {
  name: 'admin-setting-form',
  props: ['payload'],
  data () {
    return {
      setting: {},
      is_submitting: false
    }
  },
  async created () {
    try {
      const r = await this.$network_utils.getSetting({
        id: this.payload.data.id
      })
      this.setting = r
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('settings', ['fetchSettings']),
    async submit (refresh) {
      try {
        const r = await this.$network_utils.updateSetting(this.setting)
        if (refresh) {
          this.fetchSettings()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the following tag: ${r.var}`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
